import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../redux/actions/ip';

const genRoomId = () => Math.random().toString(36).substr(2, 9);

const useVideoMeetingsFunctions = () => {
  const history = useHistory();
  const userLogin = useSelector(state => state.userLogin);
  const currentUser = userLogin?.userInfo?.data?.user;

  const [selectedUser, setSelectedUser] = useState(null);
  const [availableUsers, setAvailableUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState(null); // 'direct-call' or 'group-meeting'

  const fetchAvailableUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users/video-call-users`, { withCredentials: true });
      const users = Array.isArray(response.data) ? response.data : response.data?.data || [];
      // Users are already filtered server-side (org-scoped, excluded roles, current user excluded)
      setAvailableUsers(users);
    } catch (error) {
      console.error('Error fetching users:', error);
      setAvailableUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableUsers();
  }, [currentUser?._id]);

  const handleDirectCall = () => {
    if (!selectedUser) return;
    // Start direct call in group meeting room (1-on-1)
    const roomId = genRoomId();
    history.push(`/group-video-call/${roomId}?directCall=${selectedUser._id}`);
  };

  const handleStartGroupMeeting = () => {
    const roomId = genRoomId();
    history.push(`/group-video-call/${roomId}`);
  };

  return {
    selectedUser,
    setSelectedUser,
    availableUsers,
    setAvailableUsers,
    loading,
    setLoading,
    mode,
    setMode,
    fetchAvailableUsers,
    handleDirectCall,
    handleStartGroupMeeting,
  };
};

export default useVideoMeetingsFunctions;
